export enum SubscriptionChangeUIActions {
    none = 'None',
    updateSubscriptionNoInvoice = 'UpdateSubscriptionVerify',
    downgradeSubscriptionVerify = 'DowngradeSubscriptionVerify',
    cancelDowngradeSubscriptionVerify = 'CancelDowngradeSubscriptionVerify'
}